import axios from "axios";

export const postPreviewsDownload = async (params) => {
  const query = new URLSearchParams({ ...params }).toString()

  return await axios.get(`/api/v1/preview/pdf_downloads?${query}`)
}

export const getPreviewsDownloadStatus = async ({ query = null, config }) => {
  return await axios.get( `/previews/${config.params.report_id}/download_status?${query}`, config)
}

export const putReportConditions = async (params) => {
  return await axios.put('/api/v1/preview/report_conditions', params)
}

export const getPdfStatus = async (params) => {
  const query = new URLSearchParams({ ...params }).toString()

  return await axios.get(`/api/v1/preview/pdf_status?${query}`)
}

export const postReportCoverCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/cover_customizes', params)
}

export const postReportDigestCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/digest_customizes', params)
}

export const postReportShoppingCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/shopping_customizes', params)
}

export const postReportLifeRelatedCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/life_related_customizes', params)
}

export const postReportGourmetCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/gourmet_customizes', params)
}

export const postReportCultureCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/culture_customizes', params)
}

export const postReportLargeStoreCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/large_store_customizes', params)
}

export const postReportRaiseCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/raise_customizes', params)
}

export const postReportNurseryDataCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/nursery_data_customizes', params)
}

export const postReportNurseryInfoCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/nursery_info_customizes', params)
}

export const postReportSchoolAreaCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/school_area_customizes', params)
}

export const postReportAccessCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/access_customizes', params)
}

export const postReportTrainRouteCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/train_route_customizes', params)
}

export const postReportCarCommuteCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/car_commute_customizes', params)
}

export const postReportUseAreaCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/use_area_customizes', params)
}

export const postReportWaterDamageCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/water_damage_customizes', params)
}

export const postReportPassengersCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/passengers_customizes', params)
}

export const postReportPopulationCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/population_customizes', params)
}

export const postReportHouseholdCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/household_customizes', params)
}

export const postReportCloseCustomizes = async (params) => {
  return await axios.post('/api/v1/preview/report/close_customizes', params)
}

export const getTownnaviPropertyInfos = async (params) => {
  const query = new URLSearchParams(params).toString()

  return await axios.get(`/api/v1/search/property_infos?${query}`)
}

export const getValidateDistanceFromStation = async (params) => {
  const query = new URLSearchParams(params).toString()

  return await axios.get(`/api/v1/report/validate_distance_from_station?${query}`)
}
